import { workshopRequest } from '@/network/requests/workshop'
import { jtInfoRequest } from '@/network/requests/jtInfo'
import { FilterQuery } from '@/network/interfaces/FilterQuery'

/**
 * 获取所有车间。
 */
var getWorkshops = async () => {
	var list = await workshopRequest.queryAll()

	return list.map(p => {
		return {
			label: p.name,
			value: p._id?.$oid!,
		}
	})
}

/**
 * 获取机台列表。
 * @param filter
 */
var getJTList = async (filter?: FilterQuery | undefined) => {
	var list = await jtInfoRequest.queryAll(filter)

	return list.map(p => {
		return {
			label: p.name,
			value: p._id?.$oid!,
			workshop: p.workshop_id,
		}
	})
}

/**
 * 获取所有几台，并带有车间信息。
 */
var getJTListGroupByWorkshop = async () => {
	var jt_list = await jtInfoRequest.queryAll()
	var workshop_list = await workshopRequest.queryAll()
	var result: any[] = []

	workshop_list.forEach((p, i) => {
		var array = jt_list.filter(t => t.workshop_id == p._id?.$oid)
		var obj: any = {
			label: p.name,
			value: p._id?.$oid!,
			jtList: array.map(v => {
				return {
					label: v.name,
					value: v._id?.$oid!,
				}
			}),
		}

		result.push(obj)
	})

	return result
}

export default {
	getWorkshops,
	getJTList,
	getJTListGroupByWorkshop,
}
